import React, { memo } from 'react';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import { FormHTML } from '@core/components/form/FormHTML';
import { FormInput, FormSelect } from '@core/components/form';
import { TableColumn } from '@modules/common/TableColumn';
import { TableActions } from '@modules/common/TableActions';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';
import { ProjectListNodeForm } from '../ProjectListBlock';
import { ProjectListNodeType } from '../types';

const DragHandle = SortableHandle(() => <i className="fas fa-grip-vertical" style={{ cursor: 'move', color: '#6c757d' }} />);

const VENDOR_FIELD_OPTIONS = [
  { label: 'Vendor Name', value: 'name' },
  { label: 'Subcontractor', value: 'subcontractor' },
  { label: 'Phone', value: 'phone' },
  { label: 'Email', value: 'email' },
];

const VENDOR_LAYOUT_OPTIONS = [
  { label: 'Vertical', value: 'vertical' },
  { label: 'Horizontal', value: 'horizontal' },
];

const NODE_LABELS: Record<ProjectListNodeType, string> = {
  [ProjectListNodeType.text]: 'Text',
  [ProjectListNodeType.calendarEvent]: 'Calendar Event',
  [ProjectListNodeType.vendors]: 'Vendors',
  [ProjectListNodeType.vccItems]: 'VCC Items',
};

interface ProjectListNodeItemProps {
  nodeCtrl: ProjectListNodeForm;
  onDelete: () => void;
}

export const ProjectListNodeItem = SortableElement(
  memo((props: ProjectListNodeItemProps) => {
    const { nodeCtrl, onDelete } = props;
    const nodeValue = useNonNilObservable(nodeCtrl.value$);

    return (
      <div className="d-flex align-items-start mb-2 p-2" style={{ background: '#f8f9fa', borderRadius: 4 }}>
        <TableColumn flex={0.1} minWidth={'24'} maxWidth={'24'}>
          <div className="pt-2">
            <DragHandle />
          </div>
        </TableColumn>
        <TableColumn flex={2}>
          <div className="font-weight-bold mb-1" style={{ fontSize: 12, color: '#6c757d' }}>
            {NODE_LABELS[nodeValue.type]}
          </div>
          {nodeValue.type === ProjectListNodeType.text && <FormHTML veryMinimal control={nodeCtrl.controls.content} />}
          {nodeValue.type === ProjectListNodeType.vendors && (
            <div className="d-flex flex-wrap" style={{ gap: 8 }}>
              <FormInput control={nodeCtrl.controls.vendorLimit} type="number" min={0} label="Up to" />
              <FormSelect control={nodeCtrl.controls.vendorFields} items={VENDOR_FIELD_OPTIONS} type="multiple" label="Fields" />
              <FormSelect control={nodeCtrl.controls.vendorsLayout} items={VENDOR_LAYOUT_OPTIONS} label="Layout" />
            </div>
          )}
          {(nodeValue.type === ProjectListNodeType.calendarEvent || nodeValue.type === ProjectListNodeType.vccItems) && (
            <div className="text-muted" style={{ fontSize: 13 }}>
              Auto-fills from the work order.
            </div>
          )}
        </TableColumn>
        <TableColumn flex={0.1} minWidth={'60'} maxWidth={'60'}>
          <TableActions onDelete={onDelete} />
        </TableColumn>
      </div>
    );
  }),
);
